// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","477":"LogoMakerGuestLazyComponent"}[chunkId] + "." + {"46":"d01bff2a0e513a724ed4","477":"61a013fe123e45c2482f"}[chunkId] + ".js";
};